export default __webpack_public_path__ + "static/media/serviceProvider.b76a9fab.jpeg";